import { IProfileOptionsResponse } from '@kcftech/prometheustypescriptapiclient';
import { Control, Controller } from 'react-hook-form';

import { ProfileItem, ProfileSettingDropdown, ProfileSubSection } from '../components';
import { UserSettingsFormData } from './UserProfileModal';

export type DateTimeOptionsPaneProps = Readonly<{
    options: IProfileOptionsResponse;
    className?: string;
    control: Control<UserSettingsFormData>;
}>;

export function DateTimeOptionsPane({
    options: { DateFormats, TimeFormats, TimeZones },
    className,
    control,
}: DateTimeOptionsPaneProps) {
    return (
        <ProfileSubSection className={className} title="Date/Time">
            <ProfileItem label="Date Format">
                <Controller
                    control={control}
                    name="profile.DateFormat"
                    render={({ field: { value, onChange } }) => (
                        <ProfileSettingDropdown
                            options={DateFormats}
                            value={
                                DateFormats.find((option) => option.Value === value) ??
                                DateFormats[0]
                            }
                            onConfirm={(value) => onChange(value?.Value)}
                        />
                    )}
                />
            </ProfileItem>
            <ProfileItem label="Time Format">
                <Controller
                    control={control}
                    name="profile.TimeFormat"
                    render={({ field: { value, onChange } }) => (
                        <ProfileSettingDropdown
                            options={TimeFormats}
                            value={
                                TimeFormats.find((option) => option.Value === value) ??
                                TimeFormats[0]
                            }
                            onConfirm={(value) => onChange(value?.Value)}
                        />
                    )}
                />
            </ProfileItem>
            <ProfileItem label="Time Zone">
                <Controller
                    control={control}
                    name="profile.TimeZone"
                    render={({ field: { value, onChange } }) => (
                        <ProfileSettingDropdown
                            options={TimeZones}
                            value={
                                TimeZones.find((option) => option.Value === value) ??
                                TimeZones[0]
                            }
                            onConfirm={(value) => onChange(value?.Value)}
                        />
                    )}
                />
            </ProfileItem>
        </ProfileSubSection>
    );
}
